import Image from "../../images/info1.svg";
import Image2 from "../../images/info2.svg";

export const homeObjOne = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: false,
  topLine: "Premium Products",
  headline: "IMPORT WITH PRIDE",
  description:
    "  \"A.R. Sayed Trade is your trusted importer of fish and fresh fruit. With years of experience and strong relationships with reputable suppliers, we are committed to providing the finest quality seafood and the freshest produce to our customers. Our streamlined logistics process ensures reliable and timely deliveries, while our knowledgeable team carefully selects each batch of fish and fruit to meet the highest standards of freshness, taste, and environmental responsibility. From popular varieties to exotic species, our wide selection of fish satisfies diverse needs, while our diverse range of fruits, including seasonal favorites and exotic varieties, caters to every palate. Choose A.R. Sayed Trade as your preferred importer and let us bring the ocean's bounty and nature's goodness to your doorstep, ensuring an unforgettable dining experience and promoting a healthy lifestyle.",
  buttonLable: "OUR SERVICES",
  imgStart: false,
  img: Image,
  alt: "ship",
  dark: true,
  primary: true,
  darkText: false,
  btn: "discover",
};
export const homeObjTwo = {
  id: "discover",
  lightBg: true,
  lightText: false,
  lightTextDesc: true,
  topLine: "Premium Fish",
  headline: "ENSURING BEST QUALITY",
  description:
    'A.R Sayed Trade International team will carefully follow up on each of your orders and provide you all the necessary updates and information you need. Moreover, we will ensure that the delivery time is strictly met and that the product is processed according to your specifications. For every order, here is the process we follow: "Understand well your needs, Packing design, Processing, Quality Control, and Documents".',
  buttonLable: "VIEW MORE",
  imgStart: true,
  img: Image2,
  alt: "ship",
  dark: false,
  primary: false,
  darkText: true,
  btn: "services",
};
